<template>
  <pt-scan-payment-counselor-table class="pt-scan-payment-counselor-table__withData" @getTableData="getTableData" :tableLabels="tableLabels"
                                   :totalNumber="totalNumber" :tableData="tableData" ref="table" :loading="loading">
    <slot />
  </pt-scan-payment-counselor-table>
</template>

<script>
import PtScanPaymentCounselorTable from './index'
export default {
  name: 'pt-scan-payment-counselor-table__withData',
  components: {
    'pt-scan-payment-counselor-table': PtScanPaymentCounselorTable
  },
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: Number,
    paramsData: Object,
    isFromRouter: Boolean,
    isLifeExperienceHall: Boolean,
    isScanPaymentStorage: Boolean
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: 0,
      tableData: [],
      isOutside: false,
      loading: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    },
    '$route.name': {
      handler: function (val) {
        this.getTableData(0)
      }
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.pageSize,
          sort: ['id,desc']
        },
        ...this.paramsData
      }
      if (!next) {
        this.loading = true
      }
      if (this.isLifeExperienceHall) {
        data.businessType = 'LIFE_EXPERIENCE_HALL'
      } else if (this.isScanPaymentStorage) {
        data.businessType = ['STORAGE', 'TAI_KANG']
      } else {
        if (data.businessType) {
          this.$delete(data, 'businessType')
        }
      }
      this.$store.dispatch('consultantPaymentOrder', data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取支付订单失败')
      })
    }
  }
}
</script>
